import { render, staticRenderFns } from "./DeleteMaterialModal.vue?vue&type=template&id=36985b58&"
import script from "./DeleteMaterialModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteMaterialModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports